import Vue from 'vue'
import {
  Carousel,
  CarouselItem,
  Tabs,
  Loading,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Select,
  Option,
} from 'element-ui'

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Tabs)
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
